module.exports = __webpack_public_path__ + "img/fensan.81d98422.png";